import { tunnel } from '@/webgl/tunnel'

const Landing = () => {
  return <tunnel.Out />
}

export default Landing
